const VERSION = "7.0.1";
export {
  VERSION
};
